import Placeholder from '../components/Placeholder';

function GpsSystemsPlaceholder() {
  const title = 'GPS Systems';
  const description = 'This section provides visibility into the positioning equipment installed across the fleet. It is designed to help technical teams monitor system health, identify issues quickly, and ensure reliable positioning performance on every project.';
  const features = [
    'Live status of installed GPS systems',
    'Monitoring of receiver health and connectivity',
    'Tracking of satellite reception and positioning quality',
    'Detection of communication and correction service issues',
    'Equipment inventory and installation records',
    'Alerts for offline or malfunctioning systems',
    'Access to system details, configuration information, and support resources',
  ];
  const benefits = 'By centralizing GPS system information in one location, technical teams can proactively identify problems, reduce troubleshooting time, and improve the reliability of positioning systems throughout the fleet.';

  return (
    <Placeholder
      title={title}
      description={description}
      features={features}
      benefits={benefits}
    />
  )
}

export default GpsSystemsPlaceholder;